import { apiBffMobileV1Products } from './api'

export const getMultiSuggested = async (cartId: string, providers: string) => {
  const response = await apiBffMobileV1Products.get(`/multiSuggested?cartId=${cartId}&providerId=${providers}`)

  return response.data
}
